import { __decorate } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Widget } from '@shop-builder/core/widget';
import config from '@api/config';
import PropTypes from '@shop-builder/core/prop-types';
import { findOneById } from '@api/services/tariff';
import { findOneByComponentSet } from '@api/services/offers';
import { Configurator } from '@api/services/configurator';
import { getOptions } from '@api/utils';
import { BasketAssistant } from '@api/services/basket';
import QuantityCtaDropdown from "@shop-builder/shared/QuantityCtaDropdown";
import MonthlyTariffPriceBox from "@shop-builder/shared/MonthlyTariffPriceBox";
import KissTariffsPassContainer from "@shop-builder/widgets/kiss-tariffs/kiss-tariffs-pass-container";
var KissTariffsWidget = /*@__PURE__*/ (function () {
    function KissTariffsWidget() {
        this.tariffs = [];
        this.tariffsSubIds = new Map();
        this.qtyDropdowns = [];
        this.priceBoxes = [];
        this.passesContainer = [];
        this.copaymentToggle = document.querySelector('.mod-ep-kiss-device-detail__copayment-chooser-switch') ? true : false;
        this.toggled = true;
        //selectors
        //tabs
        this.tariffGroupsTabs = '.mod-ep-kiss-tariffs__tariff-group-selection-tab';
        //radiobtns container
        this.tariffRadioBtnBarSelector = '.mod-ep-kiss-tariffs__tariff-tab';
    }
    KissTariffsWidget.prototype.hasAccordion = function () {
        return document.querySelector('.mod-ep-kiss-tariffs').classList.contains('is-accordion');
    };
    KissTariffsWidget.prototype.didMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dropdownContainers, priceBoxesContainers, _a, tariffId;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!Configurator.getTariff())
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, Configurator.calculateOffer()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        //set all groups with tariffs
                        this.tariffs = this.getAllTariffs();
                        if (!!this.validateOffer())
                            return [3 /*break*/, 4];
                        return [4 /*yield*/, this.fixOffer()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        dropdownContainers = Array.prototype.slice.call(document.querySelectorAll('.qty-container'));
                        dropdownContainers.forEach(function (container) { return _this.qtyDropdowns.push(new QuantityCtaDropdown(container)); });
                        priceBoxesContainers = Array.prototype.slice.call(document.querySelectorAll('.mod-ep-kiss-tariffs__price-box-container'));
                        priceBoxesContainers.forEach(function (container) { return _this.priceBoxes.push(new MonthlyTariffPriceBox(container)); });
                        _a = this;
                        return [4 /*yield*/, BasketAssistant.getTotalAmount()];
                    case 5:
                        _a.basketItemsAmount = _b.sent();
                        this.tariffId = Configurator.getTariff().id;
                        //set Up View
                        this.cloneBenefits();
                        this.initialSetupView();
                        // add Event Listener
                        Configurator.subscribe('offerChanged', function () {
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.validateOffer())
                                                return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.onOfferChanged()];
                                        case 1:
                                            _a.sent();
                                            return [3 /*break*/, 4];
                                        case 2: return [4 /*yield*/, this.fixOffer()];
                                        case 3:
                                            _a.sent();
                                            _a.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        tariffId = this.tariffId;
                        return [4 /*yield*/, this.setTariffWithCoPaymentState(tariffId)];
                    case 6:
                        _b.sent();
                        return [4 /*yield*/, this.onOfferChanged()];
                    case 7:
                        _b.sent();
                        return [4 /*yield*/, Configurator.setSubTariffIds(this.tariffsSubIds)];
                    case 8:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsWidget.prototype.validateOffer = function () {
        return this.getGroupOfTariffWithId(Configurator.getTariff().id) != null;
    };
    KissTariffsWidget.prototype.fixOffer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var index, tariffId, tariff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index = this.tariffs.findIndex(function (item) { return item.isStandard && item.standardGroup; });
                        tariffId = this.tariffs[0].id;
                        if (index > -1) {
                            tariffId = this.tariffs[index].id;
                        }
                        return [4 /*yield*/, findOneById(tariffId)];
                    case 1:
                        tariff = _a.sent();
                        return [4 /*yield*/, Configurator.setTariff(tariff)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // tariff => group id
    KissTariffsWidget.prototype.getGroupOfTariffWithId = function (id) {
        var index = this.tariffs.findIndex(function (el) { return el.id == id; });
        return index > -1 ? this.tariffs[index].groupId : null;
    };
    // group => tariff id
    KissTariffsWidget.prototype.getStandardTariffOfGroup = function (groupId) {
        var index = this.tariffs.findIndex(function (el) { return el.groupId == groupId && el.isStandard; });
        return index > -1 ? this.tariffs[index].id : null;
    };
    KissTariffsWidget.prototype.cloneBenefits = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                jQuery('.mod-ep-kiss-tariffs__tariff-benefits:empty').each(function () {
                    jQuery(this).append(jQuery(this).parents('.mod-ep-kiss-tariffs__tariff-group').find('.mod-ep-kiss-tariffs__tariff-group-benefits').html());
                });
                return [2 /*return*/];
            });
        });
    };
    KissTariffsWidget.prototype.addLoaded = function () {
        jQuery('.mod-ep-kiss-tariffs').addClass('loaded');
    };
    KissTariffsWidget.prototype.initialSetupView = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // precalc all prices and set it
                //add OnClickListener
                this.setUpTabsOnClick();
                this.setUpRadioBtnsOnClick();
                this.setOptionsOnChange();
                this.setAmountDropdownOnChange();
                this.setUpPassContainer();
                this.setCoPaymentToggleListener();
                // logic
                this.setUpAddToCart();
                if (this.hasAccordion()) {
                    this.setAccordionActionChangeTariffOnClick();
                }
                this.addLoaded();
                return [2 /*return*/];
            });
        });
    };
    KissTariffsWidget.prototype.onOfferChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var offer, usedOptions, tariffIdToUpdate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // set tariff id
                        this.tariffId = Configurator.getTariff().id;
                        return [4 /*yield*/, Configurator.getOffer()];
                    case 1:
                        offer = _a.sent();
                        usedOptions = offer.getUsedOptions().map(function (opt) { return parseInt(opt.id); });
                        tariffIdToUpdate = this.tariffId;
                        // update View
                        this.updateGroupSelected(this.getGroupOfTariffWithId(tariffIdToUpdate));
                        this.updateTariffSelected(tariffIdToUpdate);
                        this.updateOptionsSelected(tariffIdToUpdate, usedOptions);
                        return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsWidget.prototype.setUpPassContainer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var passesContainer, _i, passesContainer_1, container, tariffId, tariff, offer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        passesContainer = Array.prototype.slice.call(this.getElement().getElementsByClassName("mod-ep-kiss-tariffs__passes"));
                        _i = 0, passesContainer_1 = passesContainer;
                        _a.label = 1;
                    case 1:
                        if (!(_i < passesContainer_1.length))
                            return [3 /*break*/, 5];
                        container = passesContainer_1[_i];
                        tariffId = +container.dataset.tariffId;
                        return [4 /*yield*/, findOneById(tariffId)];
                    case 2:
                        tariff = _a.sent();
                        return [4 /*yield*/, findOneByComponentSet([tariff])];
                    case 3:
                        offer = _a.sent();
                        if (offer.hasAnyPasses()) {
                            this.passesContainer.push(new KissTariffsPassContainer(container, offer.getAvailablePasses().map(function (pass) { return pass.id; })));
                        }
                        else {
                            container.style.display = "none";
                        }
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 1];
                    case 5:
                        window.vf.tooltip2.init(passesContainer);
                        return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsWidget.prototype.setCoPaymentToggleListener = function () {
        var _this = this;
        if (this.copaymentToggle) {
            document.addEventListener("coPaymentToggleClicked", function () {
                return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, this.setTariffWithCoPaymentState(Configurator.getTariff().id)];
                    });
                });
            });
        }
    };
    KissTariffsWidget.prototype.updateGroupSelected = function (groupId) {
        // radio buttons
        var allGroupRadioBtns = Array.prototype.slice.call(document.querySelectorAll('.mod-ep-kiss-tariffs__tariff-group-selection-tab'));
        allGroupRadioBtns.forEach(function (el) { return el.parentElement.classList.remove('selected'); });
        var radioBtnSelected = document.querySelector('#tariff-group-' + groupId + '-tab');
        radioBtnSelected.parentElement.classList.add('selected');
        // content
        var allContentContainer = Array.prototype.slice.call(document.querySelectorAll('.mod-ep-kiss-tariffs__tariff-group'));
        allContentContainer.forEach(function (el) { return el.classList.remove('selected'); });
        var containerSelected = document.querySelector('#tariff-group-' + groupId);
        containerSelected.classList.add('selected');
    };
    KissTariffsWidget.prototype.updateTariffSelected = function (tariffId) {
        // Tariff Flag
        var allTariffFlags = Array.prototype.slice.call(document.querySelectorAll('.mod-ep-kiss-tariffs__tariff-tab'));
        allTariffFlags.forEach(function (el) { return el.parentElement.classList.remove('selected'); });
        var tariffFlag = document.querySelector('#tariff-' + tariffId + '-tab');
        tariffFlag.parentElement.classList.add('selected');
        // Tariff content
        var allTariffsContainer = Array.prototype.slice.call(document.querySelectorAll('.mod-ep-kiss-tariffs__tariff'));
        allTariffsContainer.forEach(function (el) { return el.classList.remove('selected'); });
        var tariffContainerSelected = document.querySelector('#tariff-' + tariffId);
        tariffContainerSelected.classList.add('selected');
        if (this.hasAccordion()) {
            document.getElementById("accordion-tariff-title").textContent =
                document.querySelector('.mod-ep-kiss-tariffs__tariff.selected').querySelector('.mod-ep-kiss-tariffs__tariff-title').textContent;
            document.getElementById("accordion-tariff-data-volume").textContent = document.querySelector('li.selected>.mod-ep-kiss-tariffs__tariff-tab').textContent;
        }
    };
    KissTariffsWidget.prototype.updateOptionsSelected = function (tariffId, usedOptions) {
        var optionsInTariff = Array.prototype.slice.call(Array.prototype.slice.call(document.querySelectorAll('#tariff-options-' + tariffId)).map(function (el) { return el.children; })[0]);
        optionsInTariff.forEach(function (el) {
            var isUsedOption = usedOptions.indexOf(parseInt(el.dataset.option)) > -1;
            var labelOfOption = el.querySelector('label');
            var inputOfOption = el.querySelector('input[type=checkbox]');
            if (isUsedOption) {
                inputOfOption.checked = true;
                if (!labelOfOption.classList.contains('checked')) {
                    labelOfOption.classList.add('checked');
                }
            }
            else {
                inputOfOption.checked = false;
                labelOfOption.classList.remove('checked');
            }
        });
    };
    KissTariffsWidget.prototype.handleTabChanged = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var groupId, offerComp, tariffId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        groupId = parseInt(e.srcElement.dataset.tariffGroupId);
                        offerComp = Configurator.getOffer().components;
                        tariffId = this.getStandardTariffOfGroup(groupId);
                        return [4 /*yield*/, this.setTariffWithCoPaymentState(tariffId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsWidget.prototype.handleTariffChanged = function (e, tariffId) {
        return __awaiter(this, void 0, void 0, function () {
            var offerComp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        offerComp = Configurator.getOffer().components;
                        e.stopPropagation();
                        return [4 /*yield*/, this.setTariffWithCoPaymentState(tariffId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsWidget.prototype.handleAccordionExpand = function () {
        var expandableContent = document.querySelector('.mod-ep-kiss-tariffs__accordion-content');
        var isExpanded = expandableContent.classList.contains('content-open');
        if (!isExpanded) {
            expandableContent.classList.add('content-open');
            document.querySelector('.mod-ep-kiss-tariffs__icon-arrow-down').classList.add('hidden');
            document.querySelector('.mod-ep-kiss-tariffs__icon-arrow-up').classList.remove('hidden');
        }
        else {
            expandableContent.classList.remove('content-open');
            document.querySelector('.mod-ep-kiss-tariffs__icon-arrow-down').classList.remove('hidden');
            document.querySelector('.mod-ep-kiss-tariffs__icon-arrow-up').classList.add('hidden');
            document.querySelector('.mod-ep-kiss-tariffs__icon-arrow-up').classList.add('hidden');
        }
    };
    KissTariffsWidget.prototype.handleOptionChanged = function (e, optionalService) {
        return __awaiter(this, void 0, void 0, function () {
            var checkBoxChecked, offer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        checkBoxChecked = e.target.checked;
                        return [4 /*yield*/, Configurator.getOffer()];
                    case 1:
                        offer = _a.sent();
                        if (!checkBoxChecked)
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, offer.useOption(optionalService)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, offer.cancelOption(optionalService)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsWidget.prototype.handleAmountChanged = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var amount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        amount = parseInt(e.srcElement.value);
                        if (this.basketItemsAmount + amount > BasketAssistant.MAX_ITEMS_ALLOWED) {
                            amount = BasketAssistant.MAX_ITEMS_ALLOWED - this.basketItemsAmount;
                        }
                        return [4 /*yield*/, Configurator.setAmount(amount)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Configurator.handleOfferChanged()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsWidget.prototype.getAllTariffs = function () {
        var _this = this;
        var groupsEl = Array.prototype.slice.call(document.querySelectorAll('.mod-ep-kiss-tariffs__tariff-group'));
        var tariffsIds = [];
        groupsEl.forEach(function (groupEl) {
            //'groupId': groupEl.dataset.tariffGroupId,
            Array.prototype.slice.call(groupEl.querySelectorAll('.mod-ep-kiss-tariffs__tariff-tab')).forEach(function (tariffEl) {
                var tariffId = parseInt(tariffEl.dataset.tariffId);
                tariffsIds.push({
                    'id': tariffId,
                    'isStandard': tariffEl.parentElement.classList.contains('selected'),
                    'groupId': parseInt(groupEl.dataset.tariffGroupId),
                    'standardGroup': groupEl.classList.contains('selected'),
                    'sub25TariffId': tariffEl.dataset.subTariffId != "" ? parseInt(tariffEl.dataset.subTariffId) : 0
                });
                if (tariffEl.dataset.subTariffId != "") {
                    _this.tariffsSubIds.set(tariffId, parseInt(tariffEl.dataset.subTariffId));
                }
            });
        });
        return tariffsIds;
    };
    KissTariffsWidget.prototype.setTariff = function (tariffId, subTariff) {
        return __awaiter(this, void 0, void 0, function () {
            var tariff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // get id from selected tariff element
                        //this.tariffId = subTariff.id === 0 ? tariffId : subTariff.id;
                        this.tariffId = tariffId;
                        return [4 /*yield*/, findOneById(this.tariffId)];
                    case 1:
                        tariff = _a.sent();
                        return [4 /*yield*/, Configurator.setTariff(tariff, subTariff && subTariff)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsWidget.prototype.setTariffWithCoPaymentState = function (tariffId) {
        return __awaiter(this, void 0, void 0, function () {
            var subTariff, subTariffId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.copaymentToggle && this.tariffsSubIds.has(tariffId)))
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, this.tariffsSubIds.get(tariffId)];
                    case 1:
                        subTariffId = _a.sent();
                        return [4 /*yield*/, findOneById(subTariffId)];
                    case 2:
                        subTariff = _a.sent();
                        if (subTariff) {
                            if (Configurator.getCoPaymentState() != 2 /* TOGGLE_OFF */ && Configurator.getCoPaymentState() != 3 /* NON_EXISTENT_OFF */) {
                                Configurator.setCoPaymentState(1 /* TOGGLE_ON */);
                            }
                            else {
                                Configurator.setCoPaymentState(2 /* TOGGLE_OFF */);
                            }
                        }
                        else {
                            if (Configurator.getCoPaymentState() === 2 /* TOGGLE_OFF */ || Configurator.getCoPaymentState() === 3 /* NON_EXISTENT_OFF */) {
                                Configurator.setCoPaymentState(3 /* NON_EXISTENT_OFF */);
                            }
                            else {
                                Configurator.setCoPaymentState(0 /* NON_EXISTENT */);
                            }
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        if (Configurator.getCoPaymentState() === 2 /* TOGGLE_OFF */ || Configurator.getCoPaymentState() === 3 /* NON_EXISTENT_OFF */) {
                            Configurator.setCoPaymentState(3 /* NON_EXISTENT_OFF */);
                        }
                        else {
                            Configurator.setCoPaymentState(0 /* NON_EXISTENT */);
                        }
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.setTariff(tariffId, subTariff && subTariff)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /*
   * set up Event Listener
   * */
    KissTariffsWidget.prototype.setAccordionActionChangeTariffOnClick = function () {
        var _this = this;
        var link = document.querySelector('.mod-ep-kiss-tariffs__accordion-action');
        link.addEventListener('click', function () { return _this.handleAccordionExpand(); });
    };
    KissTariffsWidget.prototype.setUpTabsOnClick = function () {
        var _this = this;
        var tabs = document.querySelectorAll('.mod-ep-kiss-tariffs__tariff-group-selection-tab');
        for (var i = 0; i < tabs.length; i++) {
            tabs[i].addEventListener('click', function (e) { return _this.handleTabChanged(e); });
        }
    };
    KissTariffsWidget.prototype.setUpRadioBtnsOnClick = function () {
        var _this = this;
        var radioBtnsInTariffGroups = document.querySelectorAll('.mod-ep-kiss-tariffs__tariff-tab');
        var _loop_1 = function () {
            var radioBtn = radioBtnsInTariffGroups[i];
            if (radioBtn instanceof HTMLElement) {
                var tariffId_1 = parseInt(radioBtn.dataset.tariffId);
                radioBtnsInTariffGroups[i].addEventListener('click', function (e) { return _this.handleTariffChanged(e, tariffId_1); });
            }
        };
        for (var i = 0; i < radioBtnsInTariffGroups.length; i++) {
            _loop_1();
        }
    };
    KissTariffsWidget.prototype.setAmountDropdownOnChange = function () {
        var _this = this;
        var amountSelectEl = Array.prototype.slice.call(document.querySelectorAll('select.mod-ep-kiss-tariffs__qty-select'));
        amountSelectEl.forEach(function (amountSelectEl) {
            amountSelectEl.addEventListener('change', function (e) { return _this.handleAmountChanged(e); });
        });
    };
    KissTariffsWidget.prototype.setOptionsOnChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var optionsDivs, tariffIds, tariffWithOptions;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        optionsDivs = Array.prototype.slice.call(document.querySelectorAll('.mod-ep-kiss-tariffs__option-item'));
                        tariffIds = this.tariffs.map(function (el) { return el.id; });
                        return [4 /*yield*/, Promise.all(tariffIds.map(function (id) {
                                return __awaiter(this, void 0, void 0, function () {
                                    var tariff, offer;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, findOneById(id)];
                                            case 1:
                                                tariff = _a.sent();
                                                return [4 /*yield*/, findOneByComponentSet([tariff])];
                                            case 2:
                                                offer = _a.sent();
                                                return [2 /*return*/, { 'id': id, 'options': getOptions(offer) }];
                                        }
                                    });
                                });
                            }))];
                    case 1:
                        tariffWithOptions = _a.sent();
                        optionsDivs.forEach(function (optionDiv) {
                            var tariffIdInDiv = parseInt(optionDiv.dataset.tariffid);
                            var optionIdInDiv = parseInt(optionDiv.dataset.option);
                            var tariffIndex = tariffWithOptions.findIndex(function (tariff) { return tariff.id == tariffIdInDiv; });
                            var tariff = tariffIndex > -1 && tariffWithOptions[tariffIndex];
                            var optionIndex = tariff && tariff.options.findIndex(function (option) { return option.id == optionIdInDiv; });
                            if (tariffIndex > -1 && optionIndex > -1) {
                                optionDiv.addEventListener('change', function (e) { return _this.handleOptionChanged(e, tariff.options[optionIndex]); });
                            }
                            else {
                                optionDiv.style.display = 'none';
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsWidget.prototype.setUpAddToCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var addToCart;
            var _this = this;
            return __generator(this, function (_a) {
                addToCart = Array.prototype.slice.call(document.querySelectorAll('.wrapper-cta-container__add-to-cart'));
                if (addToCart) {
                    if (BasketAssistant.MAX_ITEMS_ALLOWED - this.basketItemsAmount > 0) {
                        addToCart.forEach(function (cta) {
                            var tariffId = null;
                            if (!_this.hasAccordion()) {
                                tariffId = cta.closest('.mod-ep-kiss-tariffs__tariff').getAttribute('data-tariff-id');
                            }
                            var href;
                            var target = '_self';
                            if (tariffId) {
                                if (Configurator.tariffUsesCbuCheckout(tariffId)) {
                                    href = config.CBU_BASKET_URL + '';
                                    if (!window.Cypress) {
                                        target = '_blank';
                                    }
                                }
                                else {
                                    href = config.BASKET_PAGE_URL + '';
                                }
                                cta.setAttribute('href', href);
                            }
                            else {
                                href = config.BASKET_PAGE_URL + '';
                            }
                            cta.setAttribute('target', target);
                            cta.addEventListener('click', function (e) {
                                return __awaiter(_this, void 0, void 0, function () {
                                    var cbuOfferObject, _a, _b, _c, _d, _e;
                                    return __generator(this, function (_f) {
                                        switch (_f.label) {
                                            case 0:
                                                e.preventDefault();
                                                if (!Configurator.tariffUsesCbuCheckout(tariffId))
                                                    return [3 /*break*/, 3];
                                                _b = (_a = BasketAssistant).generateCbuOfferObject;
                                                return [4 /*yield*/, Configurator.getOffer()];
                                            case 1: return [4 /*yield*/, _b.apply(_a, [_f.sent()])];
                                            case 2:
                                                cbuOfferObject = _f.sent();
                                                href = config.CBU_BASKET_URL + cbuOfferObject;
                                                if (window.Cypress) {
                                                    window.location.href = href;
                                                }
                                                else {
                                                    window.open(href, '_blank', 'noopener');
                                                }
                                                return [3 /*break*/, 7];
                                            case 3:
                                                _d = (_c = BasketAssistant).addOffer;
                                                return [4 /*yield*/, Configurator.getOffer()];
                                            case 4:
                                                _e = [_f.sent()];
                                                return [4 /*yield*/, Configurator.getAmount()];
                                            case 5: return [4 /*yield*/, _d.apply(_c, _e.concat([_f.sent()]))];
                                            case 6:
                                                _f.sent();
                                                window.location.href = href;
                                                _f.label = 7;
                                            case 7: return [2 /*return*/];
                                        }
                                    });
                                });
                            });
                        });
                    }
                    else {
                        addToCart.forEach(function (cta) {
                            var tariffId = null;
                            if (!_this.hasAccordion()) {
                                tariffId = cta.closest('.mod-ep-kiss-tariffs__tariff').getAttribute('data-tariff-id');
                            }
                            var href;
                            if (!_this.hasAccordion() && Configurator.tariffUsesCbuCheckout(tariffId)) {
                                href = config.CBU_BASKET_URL + '';
                                cta.setAttribute('href', href);
                                // window.location.href = href;
                            }
                            else {
                                cta.removeEventListener('click', function (e) {
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            e.preventDefault();
                                            e.removeAttr('href');
                                            return [2 /*return*/];
                                        });
                                    });
                                });
                            }
                        });
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    KissTariffsWidget.propTypes = {
        devicelistingurl: PropTypes.String
    };
    KissTariffsWidget = __decorate([
        Widget({
            name: 'kiss-tariffs'
        })
    ], KissTariffsWidget);
    return KissTariffsWidget;
}());
export { KissTariffsWidget };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/kiss-tariffs/kiss-tariffs.ts
// module id = null
// module chunks = 